<template>
  <draggable
    class="dragArea"
    tag="ul"
    :list="subs"
    :group="{ name: 'g1' }"
    item-key="name"
    @end="$emit('changed')"
  >
    <template #item="{ element }">
      <li class="">
        <div class="py-2 px-4 my-2 flex justify-between cursor-move rounded-md items-center" v-if="!element.edit" :class="{'bg-gray-200':element.status,'bg-red-200':!element.status}">
            <div>{{ element.title }}</div>
            <div class="flex">
                <inertia-link :href="route('academic.subjecttopic.notes.list',element.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 rounded-full bg-white text-gray-700 p-1 cursor-pointer ml-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd" />
                    </svg>
                </inertia-link>
                <inertia-link :href="route('academic.subject.topic.edit',[subject,element.id])">
                    <svg class="w-7 h-7 rounded-full bg-white text-gray-700 p-1 cursor-pointer ml-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                        <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
                    </svg>
                </inertia-link>
                <svg v-if="element.status" class="w-7 h-7 rounded-full bg-white text-gray-700 p-1 cursor-pointer ml-4"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" @click="element.status = 0; $emit('changed')">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clip-rule="evenodd" />
                </svg>
                <svg v-if="!element.status" class="w-7 h-7 rounded-full bg-white text-gray-700 p-1 cursor-pointer ml-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" @click="element.status = 1; $emit('changed')">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
            </div>
        </div>

        <nested-draggable :subs="element.subtopics" :subject="subject" @end="$emit('changed')" />
      </li>
    </template>
  </draggable>
</template>
<script>
import draggable from "vuedraggable";
import BreezeInput from '@/Components/Input';
export default {
    emits: ['changed'],
    props: {
        subs: {
            required: true,
            type: Array
        },
        subject: {
            required: true,
            type: [String, Number]
        }
    },
    components: {
        draggable,
        BreezeInput
    },
    name:'nested-draggable',
    data(){
        return{

        }
    }
};
</script>
<style scoped>
li .dragArea{
    margin-left: 20px;
}
</style>
